import React from 'react';
import Header from '../components/header';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Layout from '../components/layout';
const Home: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

 
    return (
        <Layout>
            <Header title='Home'>
                <Header.Right>
                    {/* <button className='bg-success text-white text-sm px-5 py-2 rounded-md font-medium hover:bg-[#666666]'>Add New Facility</button>
                    <button className='bg-secondary text-white text-sm px-5 py-2 rounded-md font-medium hover:bg-[#7b5f54]'>Bulk Actions</button> */}
                </Header.Right>
            </Header>
            <div className='flex-grow overflow-auto'>
                <div className='flex justify-center items-center gap-20 p-20'>
                    Under Construction
                    {/*  <img src={noImg} alt="" /> */}
                </div>
            </div>

        </Layout>
    );
};

export default Home;